import * as angular from "angular";

angular
  .module('bringoz.admin.fulfillment')
  .constant('FulfillmentStep_PN', {
    database: 'fulfillmentStep',
    isBranchEntity: true,
    events: {
      onCreate: 'FulfillmentStepCreated',
      onChange: 'FulfillmentStepChanged'
    }
  });
